import React, { useState, useCallback } from 'react'
import { CollapsibleContainer } from '@corratech/pylot-ui'
import { useTranslation } from 'next-i18next/pages'
import type { CategoryTree, Maybe } from '@pylot-data/pylotschema'
import { SubCategoriesProps } from '../../FilterTypes'
import { useRouter } from 'next/router'
import cn from 'classnames'

// TODO: replace with a separate stylesheet
import s from '../../SidebarFilter/SidebarFilter.module.scss'

export const SubCategories = (props: SubCategoriesProps): JSX.Element => {
    const { t } = useTranslation(['plp'])
    const history = useRouter()
    const {
        applyFilter,
        category,
        categoryUrlSuffix,
        navigateSubcategoriesByUrl = false
    } = props
    const [expand, setExpand] = useState(true)
    const [isInnerCategory, setIsInnerCategory] = useState(false)
    const [activeNavigation, setActiveNavigation] = useState(category.url_path)
    const isApplied = true
    const children: Maybe<Array<Maybe<CategoryTree>>> | undefined =
        category.children

    const handleCategoryRedirect = useCallback(
        (item, isInner) => {
            if (!isInner && !isInnerCategory) {
                history.push(`${item.url_key}${categoryUrlSuffix || '.html'}`)
                return false
            }

            setActiveNavigation(item.id)
            setIsInnerCategory(!!isInner)
            applyFilter(
                {
                    requestVar: 'category_uid',
                    value_string: item.id
                },
                isApplied
            )
        },
        [applyFilter, categoryUrlSuffix, isApplied, isInnerCategory]
    )

    const categoryList = (
        subcategoryList?: Maybe<Array<Maybe<CategoryTree>>>,
        shouldDoFilter = false
    ) =>
        subcategoryList &&
        subcategoryList.map((item, index) => {
            if (!item) {
                return ''
            }
            return (
                <li
                    key={index}
                    className={
                        item.url_path === activeNavigation ? s['active'] : ''
                    }
                >
                    {!shouldDoFilter ? (
                        <span
                            onClick={(e) => {
                                e.preventDefault()
                                handleCategoryRedirect(item, false)
                            }}
                            aria-hidden="true"
                        >
                            {item.name}
                        </span>
                    ) : (
                        <span
                            onClick={(e) => {
                                e.preventDefault()
                                handleCategoryRedirect(item, true)
                            }}
                            aria-hidden="true"
                        >
                            {item.name}
                        </span>
                    )}
                    {item.url_path === category.url_path &&
                        Array.isArray(children) &&
                        children.length !== 0 && (
                            <ul>{categoryList(children, true)}</ul>
                        )}
                </li>
            )
        })

    return (
        <CollapsibleContainer
            isOpen={expand}
            title={t('toolbar|Categories')}
            onOpen={() => setExpand(true)}
            onClose={() => setExpand(false)}
            classes={cn(s['accordion'], s['category-tree'])}
        >
            <ul>{categoryList(children, !navigateSubcategoriesByUrl)}</ul>
        </CollapsibleContainer>
    )
}
